import type { CurrentDocumentContextEntry } from '../../types'

/**
 * A table cell already under review gets its text from the table's table_html
 * reference, and the backend anchors to it by parsing the cell's <p id> out of
 * that HTML - so the cell's own target entry is redundant and can be dropped.
 */
export function omitTableCellTargets(
  entries: CurrentDocumentContextEntry[],
  targetIdsInTables: ReadonlySet<string>
): CurrentDocumentContextEntry[] {
  if (targetIdsInTables.size === 0) return entries

  return entries.filter((entry) => {
    const id = 'id' in entry ? entry.id : undefined
    const isCoveredByTable = id != null && targetIdsInTables.has(id)
    return !isCoveredByTable
  })
}
